import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { content: String }
  static targets = ["text"]

  copy() {
    navigator.clipboard.writeText(this.contentValue).then(() => {
      if (this.hasTextTarget) {
        const originalText = this.textTarget.textContent
        this.textTarget.textContent = "Copié !"
        this.element.classList.add("bg-green-100", "text-green-700")
        this.element.classList.remove("bg-indigo-50", "text-indigo-700")

        setTimeout(() => {
          this.textTarget.textContent = originalText
          this.element.classList.remove("bg-green-100", "text-green-700")
          this.element.classList.add("bg-indigo-50", "text-indigo-700")
        }, 2000)
      }
    }).catch((err) => {
      console.error("Erreur copie:", err)
      // Fallback pour HTTP
      const textArea = document.createElement("textarea")
      textArea.value = this.contentValue
      textArea.style.position = "fixed"
      textArea.style.left = "-999999px"
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand("copy")
        if (this.hasTextTarget) {
          const originalText = this.textTarget.textContent
          this.textTarget.textContent = "Copié !"
          setTimeout(() => { this.textTarget.textContent = originalText }, 2000)
        }
      } catch (e) {
        console.error("Fallback copie échoué:", e)
      }
      document.body.removeChild(textArea)
    })
  }
}
